import Overview from './Overview'
import enhance from './Overview.enhancer'

export default enhance(Overview)



// WEBPACK FOOTER //
// ./src/containers/organisation/Overview/index.js